import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import "./index.css";
import axios from "axios";
import Comment from "../../components/Comment";
import { updateAlert, updateProjects, updateUnapprovedProjects } from "../../redux/actions";
import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import getDate from "../../../../utils/getDate";
import { Avatar as MuiAvatar, AvatarGroup } from "@mui/material";
import Avatar, { genConfig } from 'react-nice-avatar';
import { stringAvatar } from "../../../../utils/muiAvatar";
import Divider from "../../components/Divider";
import NoData from "../../components/NoData";

function ProjectPage(props) {
  const {
    user,
    projects,
    unapprovedProjects,
    handleAlert,
    handleProjects,
    handleUnapprovedProjects
  } = props

  const navigate = useNavigate();

  const pid = parseInt(useParams().pid);
  const [project, setProject] = useState({});
  const [rejectReasonOpen, setRejectReasonOpen] = useState(false)

  const getProject = (uid, pid) => {
    return axios({
      method: "post",
      url: `/api/m2d/projects/getProjectById`,
      data: {
        uid: uid,
        pid: pid
      }
    })
  }

  useEffect(() => {
    if (!user.id) {
      navigate("/login");
    }
    const handleProject = async () => {
      if (projects === null && unapprovedProjects === null) {
        // if both empty
        // pull
        const res = await getProject(user.id, pid)
        if (res.data === "Access denied!" || res.data === "") {
          navigate("/m2d/projects")
        } else {
          setProject(res.data);
        }
      } else {
        // concat two lists
        const new_projects = projects ? (unapprovedProjects ? projects.concat(unapprovedProjects) : projects) : (unapprovedProjects ? unapprovedProjects : []);
        // find the project inside
        let this_project = new_projects.find(proj => proj.id === pid)
        if (this_project) {
          // if found
          if (this_project.Goal) {
            setProject(this_project);
          } else {
            const res = await getProject(user.id, pid)
            if (res.data === "Access denied!" || res.data === "") {
              navigate("/m2d/projects");
            } else {
              setProject(res.data);
              // set global state
              if (res.data.approveStatus === 'Approved') {
                const new_projects = projects.map(proj => {
                  if (proj.id === pid) {
                    return res.data
                  }
                  return proj
                })
                handleProjects(new_projects)
              } else {
                // set global state
                const new_projects = unapprovedProjects.map(proj => {
                  if (proj.id === pid) {
                    return res.data
                  }
                  return proj
                })

                handleUnapprovedProjects(new_projects)
              }

            }
          }
        } else {
          navigate("/m2d/projects")
        }
      }
    }
    handleProject()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const handleMore = (e) => {
    navigate(`/m2d/models/${e.target.id}`);
  };

  const handleReject = () => {
    if (project.approveStatus === 'Rejected') {
      setRejectReasonOpen(true)
    }
  }

  const handleRejectReasonClose = () => {
    setRejectReasonOpen(false)
  }

  const handleOwner = (uid) => {
    navigate(`/m2d/profile?uid=${uid}`);
  }

  return (
    <div className="page-content">
      <div className="proj-pg-content">
        <div className="proj-page-content">
          <div className="model-pg-title">
            <div className="title-content">
              <div className="avatar">
                <AvatarGroup max={3}>
                  {project.users && project.users.map((user, index) => {
                    return <div key={user.id} onClick={() => handleOwner(user.id)}>
                      {user.avatar ? (
                        <MuiAvatar key={user.id}><Avatar style={{ width: '29px', height: '29px' }} {...genConfig(JSON.parse(user.avatar))} /></MuiAvatar>
                      ) : (
                        <MuiAvatar {...stringAvatar(`${user.firstName} ${user.lastName}`, {}, true, true)} key={user.id} />
                      )}
                    </div>
                  }
                  )}
                </AvatarGroup>
              </div>
              {project.name}
            </div>
            <div className="title-left">
            </div>

            <div className="title-right">
              {project.users && project.users.find(user => user.id === props.user.id) ? (
                <div className={`model-pg-status${project.approveStatus === 'Rejected' ? '-rejected'
                  : (
                    project.approveStatus === 'Approved' ? '-approved'
                      : ''
                  )
                  }`} onClick={handleReject}>{project.approveStatus}</div>
              ) : null}
            </div>
          </div>
          <Divider />
          <div className="proj-info">
            <div className="proj-left">
              <div className="proj-pg-head">Description</div>
              <div className="proj-pg-text">{project.description}</div>
              <div className="proj-pg-head">Goal</div>
              <div className="proj-pg-text">{project.goal}</div>
            </div>
            <div className="proj-right">
              <div
                className="right-block-title"
              >
                Models
              </div>
              <div className="proj-pg-model-list">
                {project.m2dModels && project.m2dModels.length > 0
                  ? project.m2dModels.map((model) => {
                    return (
                      <div className="item" key={model.id} id={model.id} onClick={handleMore}>
                        <div className="">{model.name} v{model.version}</div>
                        <div className="proj-model-detail">- {model.details}</div>
                      </div>
                    );
                  })
                  : (
                    <NoData style={{ height: "150px", marginTop: 0 }} />
                  )}
              </div>
              <Divider />
              {project.approveStatus === "Approved" ? (
                <div className="project-comment">
                  <Comment
                    project={project}
                    user={user}
                    handleAlert={handleAlert}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>


        {/* ---------- reject reason dialog ---------- */}
        {project.m2dProjectRejects && project.m2dProjectRejects.length > 0 ? (
          <Dialog
            open={rejectReasonOpen}
            onClose={handleRejectReasonClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Reason:
            </DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
              {project.m2dProjectRejects.map(rej => {
                return (
                  <DialogContentText key={rej.id}>
                    {getDate(rej.time)}: {rej.rejectReason}
                  </DialogContentText>
                )
              })}
            </DialogContent>
          </Dialog>
        ) : null}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    projects: state.m2d.projects,
    unapprovedProjects: state.m2d.unapprovedProjects
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },

    handleProjects(projects) {
      updateProjects(projects)(dispatch);
    },

    handleUnapprovedProjects(projects) {
      updateUnapprovedProjects(projects)(dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectPage);
